/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InstitutionsApi } from '../api/institutions.api';
import { switchMap, map } from 'rxjs/operators';
import { InstitutionsData, Institutions } from '../../../interfaces/masters/institutions';

@Injectable()
export class InstitutionsService extends InstitutionsData {

  constructor(private api: InstitutionsApi) {
    super();
  }


  list(): Observable<Institutions[]> {
    return this.api.list();
  }

  getById(url:string): Observable<Institutions>{
      return this.api.getById(url);
  }

  create(url: string, data:Institutions): Observable<Institutions> {
    return this.api.add(url,data);
  }

  update(url: string, data:Institutions): Observable<Institutions> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
